/**
 * Cover image URL. Prefer API-signed URL (private bucket); fall back to regional S3 URL.
 */
export function getCoverImageUrl(filename, signedUrl, folder = "books") {
  if (signedUrl) return signedUrl;
  if (!filename) return "";
  if (filename.startsWith("http://") || filename.startsWith("https://")) {
    return filename;
  }

  const bucket = process.env.REACT_APP_AWS_BUCKET_NAME;
  const region = process.env.REACT_APP_AWS_BUCKET_REGION || "ap-south-1";
  if (!bucket) return "";

  const key = filename.includes("/") ? filename : `${folder}/${filename}`;
  return `https://${bucket}.s3.${region}.amazonaws.com/${key}`;
}

export function getBookFrontCoverUrl(book) {
  return getCoverImageUrl(book?.imageCoverFront, book?.imageCoverFrontUrl, "books");
}

export function getBookBackCoverUrl(book) {
  return getCoverImageUrl(book?.imageCoverBack, book?.imageCoverBackUrl, "books");
}

export function getSetCoverUrl(set) {
  return getCoverImageUrl(set?.cover, set?.coverUrl, "setCovers");
}

export function getCoverSrc(data, coverKey, isSet) {
  if (!data || !coverKey) return "";
  if (isSet) {
    return getCoverImageUrl(coverKey, data.coverUrl, "setCovers");
  }
  if (coverKey === data.imageCoverBack) {
    return getBookBackCoverUrl(data);
  }
  return getCoverImageUrl(coverKey, data.imageCoverFrontUrl, "books");
}
